import { MyOptionsOrGroups, SelectProps } from '@procsea/design-system'

interface RetrieveEntityFromValueArgs<Entity, Key, Value, IsMulti extends boolean> {
  equalityKey: Key
  multiple?: IsMulti
  options?: MyOptionsOrGroups<Entity>
  value?: SelectProps<Value, IsMulti>['value']
}

export const retrieveEntityFromValue = <
  Entity extends { [key: string]: any },
  Key extends keyof Entity,
  Value extends Entity[Key],
  IsMulti extends boolean,
>({
  equalityKey,
  multiple,
  options,
  value,
}: RetrieveEntityFromValueArgs<Entity, Key, Value, IsMulti>):
  | Entity[]
  | Entity
  | undefined
  | null => {
  if (value === null) {
    return null
  }

  if (value === undefined) {
    return undefined
  }

  const flatOptions = options?.flatMap(item => ('options' in item ? item.options : [item]))

  return multiple
    ? flatOptions
        ?.filter(option =>
          (value as SelectProps<Value, true>['value'])?.includes(option.value[equalityKey])
        )
        .map(({ value: entity }) => entity)
    : flatOptions?.find(option => option.value[equalityKey] === value)?.value
}
